export const REFUNDING_SOLUTION_OPTIONS = [
  { value: "uniform", label: "Uniform — Level Savings" },
];

export const enabledRefundingSolutionType = () => "uniform";

// Older saved values described principal timing, the opposite of savings timing.
export function normalizeRefundingSolutionType(value) {
  if (value === "upfront" || value === "deferred") return "upfront";
  if (value === "back_end" || value === "accelerated") return "back_end";
  return "uniform";
}
